export const teamMembers = [
  {
    name: "Allan Ahmed",
    position: "Team Lead | Frontend Developer",
    src: "/assets/meetOurTeam/allan.jpg",
    linkedin: "https://www.linkedin.com/in/allan-ahmed/",
  },
  {
    name: "Iman Zuher",
    position: "Frontend Developer",
    src: "/assets/meetOurTeam/iman.jpg",
    linkedin: "https://www.linkedin.com/in/iman-zuher/",
  },
  {
    name: "Ahmed Rashid",
    position: "Frontend Developer",
    src: "/assets/meetOurTeam/ahmed.jpg",
    linkedin: "https://www.linkedin.com/in/ahmed-rashid-8a9b9116b/",
  },
  {
    name: "Noora Hakim",
    position: "Frontend Developer",
    src: "/assets/meetOurTeam/noora.jpg",
    linkedin: "https://www.linkedin.com/in/noora-hakim-156144244/",
  },
  {
    name: "Hakam Shakir",
    position: "Frontend Developer",
    src: "/assets/meetOurTeam/hakam.jpg",
    linkedin: "https://www.linkedin.com/in/hakam-shakir-31b358204/",
  },
  {
    name: "Marwa Salameh",
    position: "Frontend Developer",
    src: "/assets/meetOurTeam/marwa.jpg",
    linkedin: "https://www.linkedin.com/in/marwa-salameh/",
  },
  {
    name: "Zakaria Ahmad",
    position: "Frontend Developer",
    src: "/assets/meetOurTeam/zakaria.jpg",
    linkedin: "https://www.linkedin.com/in/zakaria-ahmad-76754a239/",
  },
  {
    name: "Parykhan Jameel",
    position: "Frontend Developer",
    src: "/assets/meetOurTeam/parykhan.jpg",
    linkedin: "https://www.linkedin.com/in/parykhan-jameel-5b5078241/",
  },
  {
    name: "Lawen Sardar",
    position: "Frontend Developer",
    src: "/assets/meetOurTeam/lawen.jpg",
    linkedin: "https://www.linkedin.com/in/lawen-sardar/",
  },
  {
    name: "Aya Ali",
    position: "Frontend Developer",
    src: "/assets/meetOurTeam/default.jpeg",
    linkedin: "https://www.linkedin.com/in/aya-ali-5b46bb180/",
  },
  {
    name: "Nawal Muhammed",
    position: "Frontend Developer",
    src: "/assets/meetOurTeam/Nawal.png",
    linkedin: "https://www.linkedin.com/in/nawal-muhammad-382b7837/",
  },
  {
    name: "Zryan Muhammed",
    position: "Frontend Developer",
    src: "/assets/meetOurTeam/default.jpeg",
    linkedin: "https://www.linkedin.com/in/zryan-muhammed-9b5478216/",
  },
  {
    name: "Paywand Mohammed",
    position: "Frontend Developer",
    src: "/assets/meetOurTeam/paywand.png",
    linkedin: "https://www.linkedin.com/in/paywand-mohammed-b306581a4/",
  },
];
